const FOCUSABLE_DEFAULT_ELEMENTS = [
  "A",
  "INPUT",
  "TEXTAREA",
  "SELECT",
  "DETAILS",
];
const FOCUSABLE_CUSTOM_ELEMENTS = [
  "NES-BUTTON",
  "NES-CHECKBOX",
  "NES-CHIPCARD-INPUT",
  "NES_EXPANDABLE",
  "NES-FIELDSET",
  "NES-INPUT",
  "NES-LINK",
  "NES-RADIO-BUTTON",
  "NES-RADIO-BUTTON-GROUP",
  "NES-RADIO-PANEL",
  "NES-SEARCH-INPUT",
  "NES-SELECT",
  "NES-SELECTABLE",
  "NES-SELECTABLE-GROUP",
  "NES-SELECTABLE-RADIO",
  "NES-SELECTABLE-CHECKBOX",
  "NES-STEPPER",
  "NES-TOGGLE",
];

export { FOCUSABLE_CUSTOM_ELEMENTS as F, FOCUSABLE_DEFAULT_ELEMENTS as a };
